import { getAccount } from "@wagmi/core";
import { fetchXpBalanceWei, formatOwxp } from "../lib/stakingData.js";
import { getStakingEnv, isHexAddress } from "../lib/env.js";

/** @type {ReturnType<typeof setInterval> | null} */
let pollTimer = null;

function formatAddress(addr) {
  if (!addr || addr.length < 10) return addr ?? "";
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

/**
 * Full-precision OWXP string (18 decimals, no rounding).
 * @param {bigint} wei
 */
export function formatOwxpExact(wei) {
  return formatOwxp(wei);
}

/**
 * Update `#stat-owxp`, `#stat-wallet`, and optional `#inv-stat-owxp`.
 * @param {import("@wagmi/core").Config | null} config
 */
export async function syncWalletXpBalance(config) {
  const xpEl = document.getElementById("stat-owxp");
  const walletEl = document.getElementById("stat-wallet");
  const invXpEl = document.getElementById("inv-stat-owxp");

  if (!config) {
    if (xpEl) xpEl.textContent = "—";
    if (walletEl) walletEl.textContent = "Not connected";
    if (invXpEl) invXpEl.textContent = "—";
    return;
  }

  const { address } = getAccount(config);
  if (!address) {
    if (xpEl) xpEl.textContent = "—";
    if (walletEl) walletEl.textContent = "Not connected";
    if (invXpEl) invXpEl.textContent = "—";
    return;
  }

  if (walletEl) walletEl.textContent = formatAddress(address);
  if (walletEl) walletEl.title = address;

  const xpAddr = getStakingEnv().owlexXp;
  if (!isHexAddress(xpAddr)) {
    if (xpEl) xpEl.textContent = "—";
    if (invXpEl) invXpEl.textContent = "—";
    return;
  }

  try {
    const wei = await fetchXpBalanceWei(config, xpAddr, address);
    const exact = formatOwxpExact(wei);
    if (xpEl) {
      xpEl.textContent = exact;
      xpEl.title = `${exact} OWXP`;
    }
    if (invXpEl) {
      invXpEl.textContent = exact;
      invXpEl.title = `${exact} OWXP`;
    }
  } catch (err) {
    console.warn("[owlex-staking] owxp balance", err);
    if (xpEl) xpEl.textContent = "—";
    if (invXpEl) invXpEl.textContent = "—";
  }
}

/**
 * Poll OWXP balance on an interval after wagmi is ready.
 * @param {import("@wagmi/core").Config} config
 */
export function startWalletXpBalancePolling(config) {
  if (pollTimer != null) return;

  const tick = () => void syncWalletXpBalance(config);
  tick();
  pollTimer = setInterval(tick, 30_000);

  window.addEventListener("owlex:account", tick);
  window.addEventListener("owlex:trait-applied", tick);
  window.addEventListener("owlex:staking-refresh", tick);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") tick();
  });
}
